import React from "react";
import { motion } from "framer-motion";

export function SectionKicker({ children }) {
    return (
        <p className="text-xs tracking-[0.32em] uppercase font-medium text-dr-blue mb-4">
            {children}
        </p>
    );
}

export function SectionHeading({ children, className = "" }) {
    return (
        <h2
            className={`font-display font-bold text-dr-navy text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight ${className}`}
        >
            {children}
        </h2>
    );
}

export function FadeIn({ children, delay = 0, y = 24, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function Stat({ value, label }) {
    return (
        <div className="border-t border-dr-silver pt-5">
            <div className="font-display text-4xl md:text-5xl font-bold text-dr-navy tracking-tight">{value}</div>
            <div className="text-xs uppercase tracking-[0.24em] text-dr-dark/60 mt-2">{label}</div>
        </div>
    );
}
